import { Table } from 'components/table'
import { IRecipePermissionDTO } from 'data/dtos/automation/i-recipe-permission-dto'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { ChangeEvent, MouseEvent, useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadDTO[] = [
  {
    id: 'recipeName',
    label: 'Receita',
    width: 3,
    type: 'text',
  },
]

const RecipePermissionList: React.FC = () => {
  const [page, setPage] = useState<number>(0)
  const [search, setSearch] = useState<string>('')
  const [rowsCount, setRowsCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [rowsPerPage, setRowsPerPage] = useState<number>(100)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [orderByDirection, setOrderByDirection] = useState<boolean>(true)
  const [recipesPermissionsList, setRecipesPermissionsList] = useState<IRecipePermissionDTO[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadRecipesPermissions = async (isSearch?: boolean) => {
    if (!isSearch) {
      setIsLoading(true)
    }

    await api
      .post('/recipes-permissions/list', { search, page, rowsPerPage, columnOrder })
      .then((response) => setRecipesPermissionsList(response.data.data))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    await api
      .post('/recipes-permissions/count', { search })
      .then((response) => setRowsCount(response.data.data.count))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    setIsLoading(false)
  }

  const handleDelete = async () => {
    await api
      .delete(`/recipes-permissions/${recordToDelete}`)
      .then(async () => await loadRecipesPermissions())
      .catch((error) => console.log(error.response?.data))
  }

  const searchChange = (value: string) => {
    setSearch(value)
  }

  const handleClose = () => {
    setModalIsOpen(false)
  }

  const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    event!.preventDefault()
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleCloseDelete = () => {
    setModalIsOpen(false)
    handleDelete()
  }

  const handleDeleteButton = (e: MouseEvent<any, any>, id: string) => {
    e.stopPropagation()
    setModalIsOpen(true)
    setRecordToDelete(id)
  }

  const handleSortChange = (index: number) => {
    columnOrder[index] = columnOrder[index] === 'ASC' ? 'DESC' : 'ASC'

    setColumnOrder(columnOrder)
    setOrderByDirection(!orderByDirection)
  }

  const tabOptions = [
    {
      title: 'Todas',
      size: rowsCount,
      handleClick: () => {},
    },
  ]

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadRecipesPermissions()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadRecipesPermissions()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Table.Root>
      <Table.Info
        title='Permissões a Receitas'
        route='/recipes-permissions/new'
        subTitle='Dados coletados sobre os logs de execução das receitas de automação.'
      />

      <Table.tabs options={tabOptions} />
      <Table.SearchBar
        value={search}
        handleChange={searchChange}
      />

      <Table.Overlay
        isEmpty={recipesPermissionsList.length <= 0}
        isSearch={search.length > 0}
        isLoading={isLoading}
        route='/recipes-permissions/new'
        emptyRouteText='Adicionar recipes_permission'
        searchRouteText='Adicionar recipes_permission'
        searchMessage='Nenhum recipes_permission encontrado, você pode criar um novo recipes_permission clicando no botão'
        emptyMessage='Seja bem-vindo à página de gerenciamento de RecipesPermissionss. Até o momento, nenhum recipes_permission foi criado. Para começar, você pode criar um novo recipes_permission clicando no botão'
      >
        <Table.Wrapper
          totalRows={rowsCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          page={page}
          handleClose={handleClose}
          handleCloseDelete={handleCloseDelete}
          modalIsOpen={modalIsOpen}
        >
          <Table.Header
            handleSortChange={handleSortChange}
            setOrder={setColumnOrder}
            headCells={headCells}
            order={columnOrder}
          />
          <Table.Body
            handleDeleteButton={handleDeleteButton}
            editRoutePath='/recipes-permissions/edit'
            headCells={headCells}
            rows={recipesPermissionsList}
          />
        </Table.Wrapper>
      </Table.Overlay>
    </Table.Root>
  )
}

export default RecipePermissionList
